"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ico_close_png_1 = __importDefault(require("../../../../assets/img/ico-close.png"));
const bg_wid_gradient_png_1 = __importDefault(require("../../../../assets/img/bg_wid_gradient.png"));
const mobile_generate_OTP_png_1 = __importDefault(require("../../../../assets/img/mobile-generate-OTP.png"));
const bg_field_png_1 = __importDefault(require("../../../../assets/img/bg_field.png"));
const styles_1 = require("@mui/styles");
const familyFontConst = '"Open Sans", Helvetica, Arial, sans-serif';
const familyFontConst2 = '"Open Sans", Helvetica,Arial,sans-serif';
const paddingConst = '6px 10px 8px';
exports.default = (0, styles_1.makeStyles)(() => ({
    root: {
        '&.MuiInputBase-root': {
            fontFamily: familyFontConst,
            color: '#2f3c54'
        },
        '&.MuiInputBase-fullWidth': {
            width: '100px'
        }
    },
    dialog: {
        borderRadius: '5px',
        borderWidth: '0px',
        color: '#2f3c54',
        marginTop: '-160px',
        fontFamily: familyFontConst2,
        background: `url(${bg_wid_gradient_png_1.default}) repeat-x left bottom #fff`,
        overflow: 'hidden'
    },
    DialogContentOuter: {
        width: '550px',
        backgroundColor: '#f7f7f7',
        paddingTop: '10px'
    },
    DialogNotification: {
    // position: "absolue"
    },
    DialogContent: {
        borderWidth: 0,
        width: '550px',
        overflow: 'hidden',
        position: 'relative',
        padding: paddingConst
    },
    WrapIcon: {
        width: '169px',
        height: '345px',
        position: 'relative',
        float: 'right',
        paddingTop: '10px',
        background: `url(${mobile_generate_OTP_png_1.default}) no-repeat scroll 0 0 transparent`,
        display: 'block',
        marginTop: '73px',
        marginRight: '5px'
    },
    IconClose: {
        position: 'relative',
        background: `url(${ico_close_png_1.default}) no-repeat`,
        backgroundSize: 'contain',
        width: 16,
        height: 16,
        display: 'block',
        marginRight: '5px',
        marginTop: '2px',
        cursor: 'pointer',
        zIndex: 1103
    },
    ListItem: {
        marginTop: '-60px',
        overflow: 'hidden',
        padding: paddingConst,
        position: 'relative',
        marginLeft: '-14px',
        width: '535px'
    },
    ListItemText: {
        fontWeight: 'normal',
        padding: 0,
        color: '#2f3c54',
        marginTop: '44px'
    },
    StepTips: {
        width: '117%'
    },
    FieldGroup: {
        overflow: 'hidden',
        padding: paddingConst,
        position: 'relative'
    },
    StepTitle: {
        color: '#36b7a6',
        fontSize: '13px',
        fontWeight: 'bold',
        padding: 0,
        marginLeft: '-10px'
    },
    StepOTP: {
        margin: '10px 1px 0'
    },
    StepContent: {
        background: 'transparent',
        paddingLeft: 0,
        borderRadius: '5px',
        height: '70px',
        padding: '8px 10px',
        position: 'relative',
        display: 'block',
        width: '304px'
    },
    StepTxt: {
        float: 'left'
    },
    stepText2: {
        float: 'left',
        width: '307px',
        height: '120px',
        display: 'block',
        marginLeft: '-21px',
        borderRadius: '5px',
        padding: '8px 10px',
        position: 'relative',
        marginTop: '-9px'
    },
    InputOTP: {
        backgroundColor: 'transparent',
        display: 'inline-block',
        marginBottom: '2px',
        marginLeft: '-3px',
        padding: '4px',
        borderRadius: '5px',
        maxWidth: '100%'
    },
    OtpError: {
        color: '#ff0000',
        fontFamily: familyFontConst2,
        fontSize: '12px',
        fontWeight: 600,
        marginLeft: '-12px',
        marginTop: '3px'
    },
    typography: {
        'margin-left': '-11px',
        // 'word-break': 'break-all',
        'margin-top': '-1px',
        color: '#2f3c54',
        fontWeight: 'normal',
        fontFamily: familyFontConst2,
        fontSize: '12px'
    },
    typography2: {
        'word-break': 'break-all',
        'margin-top': '-1px',
        color: '#676f80',
        fontWeight: 'normal',
        lineHeight: 1.5,
        fontFamily: 'Helvetica,Arial,sans-serif',
        fontSize: '12px',
        width: '292px'
    },
    typography3: {
        'word-break': 'break-all',
        'margin-top': '-1px',
        color: '#676f80',
        fontWeight: 'normal',
        lineHeight: 1.5,
        fontFamily: 'Helvetica,Arial,sans-serif',
        fontSize: '12px',
        width: '294px'
    },
    OTPTitle: {
        color: '#2f3c54',
        fontWeight: 'bold',
        margin: '10px 10px 0',
        padding: '5px 0 10px',
        fontSize: '103%',
        marginTop: '15px',
        marginLeft: '19px',
        fontFamily: familyFontConst2,
        fontStyle: 'normal',
        width: '488px'
    },
    OTP: {
        borderRadius: '2px',
        background: `url(${bg_field_png_1.default}) repeat-x left top #fff`,
        border: '1px solid',
        borderColor: '#e1e5eb',
        color: '#2f3c54',
        fontWeight: 600,
        outline: '0',
        fontSize: '13px',
        width: '100px',
        height: '37px',
        maxWidth: 'inherite',
        boxSizing: 'border-box',
        verticalAlign: 'middle',
        marginLeft: '-12px'
    },
    InputFocus: {
        border: '1px solid #869cc1',
        boxShadow: 'inset #e6e6e6 0 0 4px 0',
        zIndex: 1
    },
    InputHeight: {
        height: '37px !important'
    },
    Link: {
        color: '#1480b7',
        textDecoration: 'underline',
        fontSize: '12px',
        fontWeight: 600,
        marginLeft: '-5px',
        fontFamily: familyFontConst2,
        cursor: 'pointer'
    },
    OTPLink: {
        color: '#1480b7',
        textDecoration: 'underline',
        fontSize: '12px',
        fontWeight: 600,
        marginLeft: '3px',
        fontFamily: familyFontConst2,
        cursor: 'pointer',
        paddingLeft: '4px'
    },
    SubmitOutline: {
        alignItems: 'center',
        flexWrap: 'wrap',
        paddingTop: '10px',
        margin: '10px 10px 0',
        display: 'block'
    },
    Submit: {
        boxSizing: 'border-box',
        background: 'linear-gradient(180deg, #606060 0, #505050 100%)',
        border: '1px solid #595959',
        borderRadius: '5px',
        fontWeight: 'bold',
        textAlign: 'center',
        padding: '9px 12px',
        color: '#FFF',
        display: 'block',
        float: 'left',
        fontSize: '13px',
        height: 'auto',
        lineHeight: 'normal',
        margin: 0,
        minWidth: '126px',
        outline: 0,
        position: 'relative',
        marginLeft: '8px',
        textTransform: 'none',
        textShadow: 'none',
        fontFamily: familyFontConst2,
        '&:hover': {
            background: 'linear-gradient(180deg, #606060 0, #505050 100%)'
        },
        '&:focus': {
            border: '1px solid #595959 !important',
            boxShadow: 'inset #e6e6e6 0 0 4px 0'
        }
    },
    ModifyMobileLink: {
        paddingTop: '15px',
        float: 'right',
        margin: '0 0 0 5px',
        color: '#1480b7',
        textDecoration: 'underline',
        cursor: 'pointer',
        fontSize: '12px',
        fontWeight: 600
    },
    btnPrimary: {
        color: '#676F80',
        display: 'block',
        float: 'left',
        fontSize: '14px',
        height: 'auto',
        lineHeight: 'normal',
        margin: 0,
        fontWeight: 'bold',
        outline: 0,
        position: 'relative',
        textAlign: 'center',
        textDecoration: 'none',
        textShadow: '0 1px 1px #fff'
    },
    btnLink: {
        display: 'block',
        float: 'left',
        height: '39px',
        overflow: 'hidden',
        marginTop: '-9px',
        width: '200px',
        marginLeft: '-98px'
    },
    generateNewChallengeCode: {
        margin: '-12px 10px 0 10px',
        position: 'relative',
        paddingBottom: '42px',
        width: '380px',
        height: '15px',
        paddingTop: '10px',
        display: 'block',
        fontSize: '12px',
        fontWeight: 'normal',
        marginLeft: '-5px'
    }
}));
